
import { Component, Vue } from 'vue-property-decorator'
import IconBox from '@/components/container/IconBox.vue'
import { IconDataSpan, CustomButton } from 'ui-library'
import i18n from '@/i18n'
import RedCooperationUtils from '@/utilsTenant/RedCooperationUtils'
import { navigate } from '@/utils/NavigationUtils'

@Component({
  i18n,
  components: {
    IconBox,
    CustomButton
  }
})
export default class VertragsServicesIconBox extends Vue {
  private changeMotorVersicherungsumfangUrl: string =
    window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.CHANGE_MOTORVERSICHERUNGSUMFANG_PAGE
  private changeMotorFahrleistungUrl: string =
    window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.CHANGE_MOTORFAHRLEISTUNG_PAGE
  private changeMotorFahrerkreisUrl: string =
    window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.CHANGE_MOTORFAHRERKREIS_PAGE
  private requestDamageCardUrl: string = window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_DAMAGECARD_PAGE
  private requestIvkUrl: string = window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_IVK_PAGE
  private requestAccompanyingDrivingCertificatUrl: string =
    window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_ACCOMPANYINGDRIVINGCERTIFICAT_PAGE
  private requestVehicleSaleUrl: string = window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.REQUEST_VEHICLESALE_PAGE

  public onClick(link: string): void {
    navigate(link)
  }

  get vertragsServicesIconList(): IconDataSpan[] {
    const changeMotorVersicherungsumfang: IconDataSpan = {
      iconClass: 'deckungsumfang',
      href: this.changeMotorVersicherungsumfangUrl,
      label: this.$t('vertragsServicesIcons.changeMotorVersicherungsumfang').toString()
    }
    const changeMotorFahrleistung: IconDataSpan = {
      iconClass: 'lex-fahrleistung',
      href: this.changeMotorFahrleistungUrl,
      label: this.$t('vertragsServicesIcons.changeMotorFahrleistung').toString()
    }
    const changeMotorFahrerkreis: IconDataSpan = {
      iconClass: 'fahrerkreis',
      href: this.changeMotorFahrerkreisUrl,
      label: this.$t('vertragsServicesIcons.changeMotorFahrerkreis').toString()
    }
    const requestDamageCardIcon: IconDataSpan = {
      iconClass: 'schadenskarte',
      href: this.requestDamageCardUrl,
      label: this.$t('vertragsServicesIcons.requestDamageCard').toString()
    }
    const requestIvkIcon: IconDataSpan = {
      iconClass: 'ivkDefault',
      href: this.requestIvkUrl,
      label: this.$t('vertragsServicesIcons.requestIvk').toString()
    }
    const requestAccompanyingDrivingCertificatIcon: IconDataSpan = {
      iconClass: 'ausweis_outline',
      href: this.requestAccompanyingDrivingCertificatUrl,
      label: this.$t('vertragsServicesIcons.requestAccompanyingDrivingCertificat').toString()
    }
    const requestVehicleSaleIcon: IconDataSpan = {
      iconClass: 'soldCar',
      href: this.requestVehicleSaleUrl,
      label: this.$t('vertragsServicesIcons.requestVehicleSale').toString()
    }

    if (RedCooperationUtils.isRedCooperationPartner()) {
      return [requestDamageCardIcon, requestIvkIcon, requestAccompanyingDrivingCertificatIcon, requestVehicleSaleIcon]
    } else {
      return [
        changeMotorVersicherungsumfang,
        changeMotorFahrleistung,
        changeMotorFahrerkreis,
        requestDamageCardIcon,
        requestIvkIcon,
        requestAccompanyingDrivingCertificatIcon,
        requestVehicleSaleIcon
      ]
    }
  }
}
